import { render, staticRenderFns } from "./SacElem.vue?vue&type=template&id=1552c0f6"
import script from "./SacElem.vue?vue&type=script&lang=js"
export * from "./SacElem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports